export default class GetSolutionMinorVersionContentError extends Error {
}
